(function ($) {

    $(document).ready(function () {

        $(".section_home_banner_slider .slick-slider").slick({
            infinite: true,
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            speed: 500,
            fade: true,
            adaptiveHeight: false,
            cssEase: 'linear',
            autoplaySpeed: 6000,
            responsive: [
                {
                    breakpoint: 768,
                    adaptiveHeight: true
                }

            ]
        });

    });

})(jQuery);